export default __webpack_public_path__ + "static/media/bannerDesktop.3bfba748.png";